import { combineReducers } from 'redux';
import { user } from './user';
import { organisations } from './organisations';
import { products } from './products';
import { teams } from './teams';
import authorisation from './authorisation';
import { loginStatus } from './loginStatus';
import { noAccessUserOrganisations } from './noAccessUserOrganisations';
import { noAccessUserTeams } from './noAccessUserTeams';
export var reducer = combineReducers({
  user: user,
  organisations: organisations,
  teams: teams,
  authorisation: authorisation,
  products: products,
  loginStatus: loginStatus,
  noAccessUserOrganisations: noAccessUserOrganisations,
  noAccessUserTeams: noAccessUserTeams
});